enum BemobiMessageType {
	OK = 'ok',
	PAYMENT_ERROR = 'payment-error',
	INTERNAL_SERVER_ERROR = 'internal-server-error',
	READ_SESSION_FAILED = 'read-session-failed',
}

enum BemobiPaymentStatus {
	CONFIRMED = 'CONFIRMED',
	PENDING = 'PENDING',
	AUTHORIZED = 'AUTHORIZED',
	DENIED = 'DENIED',
	CHARGEBACK = 'CHARGEBACK',
}

type BemobiMessage = {type?: BemobiMessageType | string; status?: BemobiPaymentStatus | string};

type UseBemobiPostMessageParams = {
	setIsIframeOpen: (value: boolean) => void;
	setIsPayError: (value: boolean) => void;
};

export {BemobiMessageType, BemobiPaymentStatus};
export type {BemobiMessage, UseBemobiPostMessageParams};
